/**
 * Predictive prefetch — warms in-store navigations on user intent (hover/touch)
 * so the next page is already fetched by the time the link is clicked. This is
 * the controllable equivalent of Shopify's perf-kit predictive preloading.
 *
 * Conservative by design:
 *  - same-origin product/collection links only (the high-intent nav)
 *  - never cart / checkout / account / app-proxy paths
 *  - deduped, capped per page, low-priority rel="prefetch"
 *  - disabled on Save-Data and 2g/slow connections
 *  - purely additive: if anything fails, normal navigation is unaffected
 */
(function () {
  var conn = navigator.connection || {};
  if (conn.saveData) return;
  if (/(^|-)2g$/.test(conn.effectiveType || '')) return;

  // Only run if the browser supports <link rel="prefetch">
  var test = document.createElement('link');
  if (!(test.relList && test.relList.supports && test.relList.supports('prefetch'))) return;

  var ALLOW = /\/(products|collections)\//;
  var DENY = /\/(cart|checkout|account|orders|apps|services|admin)(\/|$)/;
  var DELAY = 65; // ms of sustained hover before we treat it as intent
  var MAX = 12;   // cap prefetches per page view
  var done = Object.create(null);
  var count = 0;
  var timer;

  function eligible(a) {
    if (!a || !a.href || a.origin !== location.origin) return false;
    if (a.hasAttribute('download')) return false;
    var path = a.pathname;
    if (!ALLOW.test(path) || DENY.test(path)) return false;
    if (a.href === location.href || done[a.href]) return false;
    return true;
  }

  function prefetch(href) {
    if (count >= MAX || done[href]) return;
    done[href] = true;
    count++;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = href;
    document.head.appendChild(link);
  }

  function linkFrom(e) {
    return e.target && e.target.closest ? e.target.closest('a') : null;
  }

  document.addEventListener('mouseover', function (e) {
    var a = linkFrom(e);
    if (!eligible(a)) return;
    clearTimeout(timer);
    timer = setTimeout(function () { prefetch(a.href); }, DELAY);
  }, { capture: true, passive: true });

  document.addEventListener('mouseout', function () { clearTimeout(timer); }, { capture: true, passive: true });

  // On touch devices a touchstart is a strong intent signal — prefetch immediately
  document.addEventListener('touchstart', function (e) {
    var a = linkFrom(e);
    if (eligible(a)) prefetch(a.href);
  }, { capture: true, passive: true });
})();
